"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GanntChart = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var GanntTreeView_1 = require("./GanntTreeView");
var lodash_1 = require("lodash");
var GanntTimeline_1 = require("./GanntTimeline");
var ganntHelpers_1 = require("./ganntHelpers");
var Navigation_1 = require("../Navigation");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var styles = {
    container: "w-full h-full flex flex-row relative",
    sidebar: "h-full relative border-gray-200 border-r flex flex-col",
    content: "flex-grow relative h-full",
    events: "absolute top-0 left-0 z-10 w-full h-full",
    headerAccent: "bg-gray-100 bg-opacity-50 flex w-1/4 border-gray-300 border-r border-b",
    header: "flex flex-row w-full",
    zoom: "absolute z-10 bottom-0 right-0 mb-3 mr-6 bg-white border border-rose-light rounded-full shadow-xl p-1",
};
var sortByDate = function (a, b) {
    return a.startsAt > b.startsAt ? 1 : a.startsAt < b.startsAt ? -1 : 0;
};
var sortGroupsByDate = function (a, b) {
    if (!a.contents && !b.contents)
        return sortByDate(a, b);
    var aEvent = a.contents
        .map(function (c) { return c.startsAt; })
        .sort();
    var bEvent = b.contents
        .map(function (c) { return c.startsAt; })
        .sort();
    return aEvent[0] > bEvent[0] ? 1 : aEvent[0] < bEvent[0] ? -1 : 0;
};
var GanntChart = function (_a) {
    var groups = _a.groups, originDate = _a.originDate, _b = _a.dayCellSize, dayCellSize = _b === void 0 ? 20 : _b, _c = _a.rowHeight, rowHeight = _c === void 0 ? 24 : _c, _d = _a.showHandles, showHandles = _d === void 0 ? false : _d, inactiveCellBackgroundColor = _a.inactiveCellBackgroundColor, weekendCellBackgroundColor = _a.weekendCellBackgroundColor, onSelectEvent = _a.onSelectEvent, onSelectDate = _a.onSelectDate, selectedDate = _a.selectedDate, divideRows = _a.divideRows, darkDays = _a.darkDays, renderingMode = _a.renderingMode, _e = _a.selectedEventIds, selectedEventIds = _e === void 0 ? [] : _e, handleContextMenu = _a.onContextMenu, handleEventAdjustment = _a.onAdjustEvent, initiallyExpanded = _a.expanded, externalExpandHandler = _a.onExpand, initiallyDisabled = _a.disabled, externalDisabledHandler = _a.onToggle, viewId = _a.viewId, canZoomIn = _a.canZoomIn, canZoomOut = _a.canZoomOut, onZoom = _a.onZoom, showToday = _a.showToday, onValueChange = _a.onValueChange;
    var _f = (0, react_1.useState)("content"), scrollControl = _f[0], setScrollControl = _f[1];
    var eventsView = (0, react_1.useRef)(null);
    var treeView = (0, react_1.useRef)(null);
    var updateControl = function (control) { return function () {
        setScrollControl(control);
    }; };
    var eventScrollListener = function () {
        var _a, _b;
        if (treeView.current) {
            treeView.current.scrollTop = (_b = (_a = eventsView.current) === null || _a === void 0 ? void 0 : _a.scrollTop) !== null && _b !== void 0 ? _b : 0;
        }
    };
    var treeScrollListener = function () {
        var _a, _b;
        if (eventsView.current) {
            eventsView.current.scrollTop = (_b = (_a = treeView.current) === null || _a === void 0 ? void 0 : _a.scrollTop) !== null && _b !== void 0 ? _b : 0;
        }
    };
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d;
        if (scrollControl === "content") {
            (_a = treeView.current) === null || _a === void 0 ? void 0 : _a.removeEventListener("scroll", treeScrollListener);
            (_b = eventsView.current) === null || _b === void 0 ? void 0 : _b.addEventListener("scroll", eventScrollListener);
        }
        else {
            (_c = eventsView.current) === null || _c === void 0 ? void 0 : _c.removeEventListener("scroll", eventScrollListener);
            (_d = treeView.current) === null || _d === void 0 ? void 0 : _d.addEventListener("scroll", treeScrollListener);
        }
        var currentEventsView = eventsView.current;
        var currentTreeView = treeView.current;
        return function () {
            currentEventsView === null || currentEventsView === void 0 ? void 0 : currentEventsView.removeEventListener("scroll", eventScrollListener);
            currentTreeView === null || currentTreeView === void 0 ? void 0 : currentTreeView.removeEventListener("scroll", treeScrollListener);
        };
    }, [scrollControl, eventsView, treeView]);
    // Track current view to determine if internal state needs to be refreshed
    var _g = (0, react_1.useState)(viewId), currentViewId = _g[0], setCurrentViewId = _g[1];
    var _h = (0, react_1.useState)(initiallyExpanded), expanded = _h[0], setExpanded = _h[1];
    var _j = (0, react_1.useState)(initiallyDisabled), disabled = _j[0], setDisabled = _j[1];
    (0, react_1.useEffect)(function () {
        if (viewId !== currentViewId) {
            setExpanded(initiallyExpanded);
            setDisabled(initiallyDisabled);
        }
    }, [
        currentViewId,
        setCurrentViewId,
        viewId,
        setDisabled,
        setExpanded,
        initiallyDisabled,
        initiallyExpanded,
    ]);
    // Manage external / internal expanded groups state.
    var handleExpanded = function (_a, active) {
        var _b;
        var id = _a.id;
        var newExpandedState = __assign(__assign({}, expanded), (_b = {}, _b[id] = active !== null && active !== void 0 ? active : false, _b));
        setExpanded(newExpandedState);
        externalExpandHandler === null || externalExpandHandler === void 0 ? void 0 : externalExpandHandler(newExpandedState);
    };
    // Manage external / internal disabled items state.
    var tree = (groups !== null && groups !== void 0 ? groups : []).reduce(function (p, c) { var _a, _b; return __spreadArray(__spreadArray(__spreadArray([], p, true), [c], false), ((_b = (_a = c.contents) !== null && _a !== void 0 ? _a : c.inlineContents) !== null && _b !== void 0 ? _b : []), true); }, []);
    var handleDisabled = function (id, active) {
        var _a;
        var newState = !(active !== null && active !== void 0 ? active : false);
        var item = tree.filter(function (s) { return s.id === id; })[0];
        var reduceContents = function (treeItem) {
            var _a, _b;
            return (_b = (_a = (treeItem !== null && treeItem !== void 0 ? treeItem : {}).contents) === null || _a === void 0 ? void 0 : _a.reduce(function (p, k) { return __spreadArray(__spreadArray(__spreadArray([], p, true), [k.id], false), reduceContents(k), true); }, [])) !== null && _b !== void 0 ? _b : [];
        };
        var items = reduceContents(item);
        var disabledState = items.reduce(function (p, id) {
            var _a;
            return (__assign(__assign({}, p), (_a = {}, _a[id] = newState, _a)));
        }, __assign(__assign({}, disabled), (_a = {}, _a[id] = newState, _a)));
        setDisabled(disabledState);
        externalDisabledHandler === null || externalDisabledHandler === void 0 ? void 0 : externalDisabledHandler(disabledState);
    };
    var contents = (0, lodash_1.flatten)((groups !== null && groups !== void 0 ? groups : [])
        .filter(function (g) { return g.id; })
        .sort(sortGroupsByDate)
        .map(function (g) { return (0, ganntHelpers_1.processGroup)(g, expanded, disabled); }));
    var handleZoom = function (zoom) { return function () {
        onZoom === null || onZoom === void 0 ? void 0 : onZoom(zoom);
    }; };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.container }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.sidebar, style: { width: 800 }, onMouseEnter: updateControl("sidebar") }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "grid grid-cols-12 border-b border-gray-200 bg-white w-full", style: { height: 60 } }, { children: [(0, jsx_runtime_1.jsx)("span", { className: "col-span-2" }, void 0), (0, jsx_runtime_1.jsx)("h4", __assign({ className: "border-gray-100 col-span-4 py-2 px-1 flex-grow flex-shrink-0 font-bold text-sm mt-auto w-1/2" }, { children: "Event" }), void 0), (0, jsx_runtime_1.jsx)("h4", __assign({ className: "border-gray-100 col-span-2 py-2 px-1 flex-grow flex-shrink-0 font-bold text-sm mt-auto w-1/4" }, { children: "Start" }), void 0), (0, jsx_runtime_1.jsx)("h4", __assign({ className: "border-gray-100 col-span-2 py-2 px-1 flex-grow flex-shrink-0 font-bold text-sm mt-auto w-1/4" }, { children: "End" }), void 0), (0, jsx_runtime_1.jsx)("h4", __assign({ className: "border-gray-100 col-span-2 py-2 px-1 flex-grow flex-shrink-0 font-bold text-sm mt-auto w-1/4" }, { children: "Days" }), void 0)] }), void 0), (0, jsx_runtime_1.jsx)(GanntTreeView_1.GanntTreeView, { rowHeight: rowHeight, contents: contents, ref: treeView, onToggleGroup: handleExpanded, expanded: expanded, disabledItems: disabled, onDisableItem: handleDisabled, onValueChange: onValueChange }, void 0)] }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({ className: styles.content, onMouseEnter: updateControl("content") }, { children: (0, jsx_runtime_1.jsx)(GanntTimeline_1.GanntTimeline, { startDate: originDate, cellWidth: dayCellSize, onSelectDate: onSelectDate, onSelectEvent: onSelectEvent, selectedDate: selectedDate, darkDays: darkDays, contents: contents, ref: eventsView, rowHeight: rowHeight, selectedEventIds: selectedEventIds, onContextMenu: handleContextMenu, inactiveCellBackgroundColor: inactiveCellBackgroundColor, weekendCellBackgroundColor: weekendCellBackgroundColor, onAdjustEvent: handleEventAdjustment, expanded: expanded, disabled: disabled, renderingMode: renderingMode, divideRows: divideRows, showToday: showToday, showHandles: showHandles }, void 0) }), void 0), (0, jsx_runtime_1.jsxs)("nav", __assign({ className: styles.zoom }, { children: [(0, jsx_runtime_1.jsx)(Navigation_1.IconButton, { icon: pro_solid_svg_icons_1.faPlus, className: "px-3", tooltip: "Zoom In", toolTipDirection: "above", disabled: !canZoomIn, onClick: handleZoom(true) }, void 0), (0, jsx_runtime_1.jsx)(Navigation_1.IconButton, { icon: pro_solid_svg_icons_1.faMinus, className: "px-3", tooltip: "Zoom Out", tooltipAlignment: "right", toolTipDirection: "above", disabled: !canZoomOut, onClick: handleZoom(false) }, void 0)] }), void 0)] }), void 0));
};
exports.GanntChart = GanntChart;
